import React, { useState, useRef, useContext } from "react";
import { toast } from "react-toastify";

import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { makeStyles } from "@material-ui/core/styles";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";

import { Grid, Slider } from "@material-ui/core";

import { SOUND_LIBRARY, DEFAULT_SOUND_ID, getSoundFile } from "../../assets/sounds";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
    tabContainer: {
        padding: theme.spacing(2),
    },
    popoverPaper: {
        width: "100%",
        maxWidth: 350,
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            maxWidth: 270,
        },
    },
    noShadow: {
        boxShadow: "none !important",
    },
    icons: {
        color: "#fff",
    },
    customBadge: {
        backgroundColor: "#f44336",
        color: "#fff",
    },
    soundRow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        marginTop: theme.spacing(1.5),
    },
    sectionTitle: {
        marginTop: theme.spacing(1),
        fontWeight: "bold",
    },
}));

const NotificationsVolume = ({ volume, setVolume }) => {
    const classes = useStyles();
    const { user } = useContext(AuthContext);

    const anchorEl = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [soundOpen, setSoundOpen] = useState(user?.notificationSoundOpen || DEFAULT_SOUND_ID);
    const [soundPending, setSoundPending] = useState(user?.notificationSoundPending || DEFAULT_SOUND_ID);

    const handleClick = () => {
        setIsOpen((prevState) => !prevState);
    };

    const handleClickAway = () => {
        setIsOpen(false);
    };

    const handleVolumeChange = (value) => {
        setVolume(value);
        localStorage.setItem("volume", value);
    };

    const handlePreview = (soundId) => {
        const audio = new Audio(getSoundFile(soundId));
        audio.volume = Number(volume);
        audio.play().catch(() => {});
    };

    const persistSound = async (field, value) => {
        try {
            // O backend emite um evento de socket com o usuário atualizado,
            // que o AuthContext já escuta e aplica sozinho.
            await api.put(`/users/${user.id}`, { [field]: value });
            toast.success("Som de notificação salvo!");
        } catch (err) {
            toastError(err);
        }
    };

    const handleChangeSoundOpen = (e) => {
        const value = e.target.value;
        setSoundOpen(value);
        persistSound("notificationSoundOpen", value);
    };

    const handleChangeSoundPending = (e) => {
        const value = e.target.value;
        setSoundPending(value);
        persistSound("notificationSoundPending", value);
    };

    return (
        <>
            <IconButton
                className={classes.icons}
                onClick={handleClick}
                ref={anchorEl}
                aria-label="Open Notifications"
                // color="inherit"
                // color="secondary"
            >
                <VolumeUpIcon color="inherit" />
            </IconButton>
            <Popover
                disableScrollLock
                open={isOpen}
                anchorEl={anchorEl.current}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                classes={{ paper: classes.popoverPaper }}
                onClose={handleClickAway}
            >
                <List dense className={classes.tabContainer}>
                    <Grid container spacing={2}>
                        <Grid item>
                            <VolumeDownIcon />
                        </Grid>
                        <Grid item xs>
                            <Slider
                                value={Number(volume)}
                                aria-labelledby="continuous-slider"
                                step={0.1}
                                min={0}
                                max={1}
                                onChange={(e, value) =>
                                    handleVolumeChange(value)
                                }
                            />
                        </Grid>
                        <Grid item>
                            <VolumeUpIcon />
                        </Grid>
                    </Grid>

                    <Divider style={{ margin: "8px 0" }} />

                    <Typography variant="body2" className={classes.sectionTitle}>
                        Sons de notificação
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        Escolha um som diferente pra cada situação. Vale só pra você.
                    </Typography>

                    <div className={classes.soundRow}>
                        <FormControl variant="outlined" size="small" fullWidth>
                            <InputLabel>Ticket novo aguardando</InputLabel>
                            <Select
                                label="Ticket novo aguardando"
                                value={soundPending}
                                onChange={handleChangeSoundPending}
                            >
                                {SOUND_LIBRARY.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>{s.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <IconButton size="small" onClick={() => handlePreview(soundPending)}>
                            <PlayArrowIcon />
                        </IconButton>
                    </div>

                    <div className={classes.soundRow}>
                        <FormControl variant="outlined" size="small" fullWidth>
                            <InputLabel>Mensagem em atendimento</InputLabel>
                            <Select
                                label="Mensagem em atendimento"
                                value={soundOpen}
                                onChange={handleChangeSoundOpen}
                            >
                                {SOUND_LIBRARY.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>{s.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <IconButton size="small" onClick={() => handlePreview(soundOpen)}>
                            <PlayArrowIcon />
                        </IconButton>
                    </div>
                </List>
            </Popover>
        </>
    );
};

export default NotificationsVolume;
